import { useState } from "react";
import { Alert, Box } from "@mui/material";
import { GetApp } from "@mui/icons-material";
import { Button } from "@gisce/oficina-virtual-components";
import { useTranslation } from "react-i18next";
import saveAs from "file-saver";
import { useAppSelector } from "@/hooks";
import { useSettingsContext } from "@/components/Settings/hooks/useSettingsContext";
import { exportInvoices } from "../services/invoices";

const InvoicesExportButton = () => {
  const { t } = useTranslation();
  const settings = useSettingsContext();
  const filter = useAppSelector(state => state.invoices.electricity.filters.currentFilter);
  const loaded = useAppSelector(state => state.invoices.electricity.loaded);
  const isFetching = useAppSelector(state => state.invoices.electricity.isFetching);
  const [exporting, setExporting] = useState(false);
  const [result, setResult] = useState<"empty" | "error" | null>(null);

  const handleExport = async () => {
    setExporting(true);
    setResult(null);
    try {
      const response = await exportInvoices(filter);
      if (response.status === 204) {
        setResult("empty");
      } else {
        const disposition = response.headers["content-disposition"];
        const filename = disposition?.match(/filename="?([^";]+)"?/i)?.[1] ?? "factures.xlsx";
        saveAs(response.data, filename);
      }
    } catch {
      setResult("error");
    } finally {
      setExporting(false);
    }
  };

  if (!settings.invoices?.enableExcelExport) {
    return null;
  } 

  return (
    <Box>
      <Box display="flex" justifyContent="flex-end">
        <Button
          variant="contained"
          color="primary"
          startIcon={<GetApp />}
          loading={exporting}
          disabled={!loaded || isFetching || exporting}
          onClick={handleExport}
        >
          {t("common:text.invoices_export_excel")}
        </Button>
      </Box>
      {result && (
        <Alert
          sx={{ mt: 2 }}
          severity={result === "empty" ? "info" : "error"}
          onClose={() => setResult(null)}
        >
          {result === "empty"
            ? t("common:text.invoices_view_empty_list")
            : t("common:text.invoices_export_error")}
        </Alert>
      )}
    </Box>
  );
};

export default InvoicesExportButton;
